// Main state object, gets populated on page load
export const state: StateType = {
  //article + list page
  // initialized: false, // add html to dom and add click handlers
  article: 'unknown',
  status: 'idle',
  sessionLoggedIn: undefined,
  pageType: null, //guards loading the script only where needed
  showOnboardingPopup: false, // reminder on first bookmark, or after n article views to make the user aware so they can bookmark something.

  //article page specific
  modalVisible: false, // pops up to indicate a non-logged in user to log in and start bookmarking.
  eventList: [], // list that /getBookmarks returns (after parsing) to check if an article is bookmarked or not. (kept in localstorage for perf reasons)

  // list page
  listHasMoreTeasers: false, // keep track of the number of teasers, so the system knows which ones to get next on load more, as well as to trigger a render.
  bookmarkList: [],
  brandName: undefined,
};
